var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7197 14.0666C15.4912 14.0666 17.7379 11.3995 17.7379 8.10935C17.7379 4.81925 15.4912 2.1521 12.7197 2.1521C9.94828 2.1521 7.70157 4.81925 7.70157 8.10935C7.70157 11.3995 9.94828 14.0666 12.7197 14.0666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5554 19.1302C21.6521 17.3431 19.9459 15.8538 17.7379 14.9602C17.1357 14.7616 16.4332 14.7616 15.9314 15.0595C14.9277 15.6552 13.9241 15.953 12.7197 15.953C11.5154 15.953 10.5117 15.6552 9.50811 15.0595C9.00629 14.8609 8.30375 14.7616 7.70156 15.0595C5.49357 15.953 3.78739 17.4424 2.88411 19.2295C2.18157 20.5203 3.28557 22.0096 4.79102 22.0096H20.6485C22.1539 22.0096 23.2579 20.5203 22.5554 19.1302Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountProfile);
export default __webpack_public_path__ + "static/media/account-profile.c9d8378ab1ed2319749c06bdefa36d91.svg";
export { ForwardRef as ReactComponent };